<script>
import Layout from "@/router/layouts/auth";
import Languages from "@/components/widgets/languages";
import EcosystemUserMenu from "@/components/widgets/ecosystem-user-menu";
import { api } from "@/state/services";

// Cancelamento da fatura pendente do Tripteev (tela dedicada, visual do Experts)
export default {
  locales: {
    pt: {
      'Back to Tripteev': 'Voltar ao Tripteev',
      'We apologize, we are unable to retrieve the information at this time.': 'Pedimos desculpas, não podemos recuperar as informações neste momento.',
      'Try again': 'Tentar novamente',
      'Cancel invoice': 'Cancelar fatura',
      'Invoice': 'Fatura',
      'Awaiting payment': 'Aguardando pagamento',
      'Check the invoice that will be canceled.': 'Confira a fatura que será cancelada.',
      'Charge': 'Cobrança',
      'Membership': 'Adesão',
      'Monthly fee': 'Mensalidade',
      'Expires on': 'Vence em',
      'Total': 'Total',
      'The PIX generated for this invoice will no longer be valid. You can generate a new invoice whenever you want.': 'O PIX gerado para esta fatura deixará de valer. Você poderá gerar uma nova fatura quando quiser.',
      'Keep invoice': 'Manter fatura',
      'The invoice has been canceled.': 'A fatura foi cancelada.',
      'Unable to cancel the invoice. It may have already been paid or canceled.': 'Não foi possível cancelar a fatura. Ela pode já ter sido paga ou cancelada.',
      'Confirm the cancellation of the invoice.': 'Confirme o cancelamento da fatura.',
      'Unable to cancel the invoice, please try again.': 'Não foi possível cancelar a fatura, tente novamente.',
    },
    es: {
      'Back to Tripteev': 'Volver a Tripteev',
      'We apologize, we are unable to retrieve the information at this time.': 'Lo sentimos, no podemos recuperar la información en este momento.',
      'Try again': 'Intentar de nuevo',
      'Cancel invoice': 'Cancelar factura',
      'Invoice': 'Factura',
      'Awaiting payment': 'En espera de pago',
      'Check the invoice that will be canceled.': 'Revisa la factura que será cancelada.',
      'Charge': 'Cobro',
      'Membership': 'Adhesión',
      'Monthly fee': 'Mensualidad',
      'Expires on': 'Vence el',
      'Total': 'Total',
      'The PIX generated for this invoice will no longer be valid. You can generate a new invoice whenever you want.': 'El PIX generado para esta factura dejará de ser válido. Podrás generar una nueva factura cuando quieras.',
      'Keep invoice': 'Mantener factura',
      'The invoice has been canceled.': 'La factura fue cancelada.',
      'Unable to cancel the invoice. It may have already been paid or canceled.': 'No fue posible cancelar la factura. Puede que ya haya sido pagada o cancelada.',
      'Confirm the cancellation of the invoice.': 'Confirma la cancelación de la factura.',
      'Unable to cancel the invoice, please try again.': 'No fue posible cancelar la factura, inténtalo de nuevo.',
    },
  },
  components: {
    Layout,
    Languages,
    EcosystemUserMenu,
  },
  data() {
    return {
      logo: require("@/assets/images/brands/tripteev.svg"),
      loading: true,
      errored: false,
      submitting: false,

      pending: null,
    };
  },
  methods: {
    load() {
      this.loading = true;
      this.errored = false;

      api
        .get("tripteev")
        .then((response) => {
          if (response.data.status == "success") {
            this.pending = response.data.pending;
          }

          // Só cancela fatura aguardando pagamento e sem pagamento parcial
          if (!this.pending || this.pending.status != "pending" || parseFloat(this.pending.paid || 0) > 0) {
            this.$router.replace("/tripteev");
          }
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      this.submitting = true;

      api
        .post("tripteev/cancel", { confirm: "yes" })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success(this.t(response.data.message));
            this.$router.push("/tripteev");
          } else {
            this.$toast.error(this.t(response.data.message));
          }
        })
        .catch(() => {
          this.$toast.error(this.t("Unable to cancel the invoice, please try again."));
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <div class="ecosystem">
      <header class="ecosystem-header">
        <router-link to="/tripteev" class="ecosystem-back">
          <i class="bx bx-left-arrow-alt" aria-hidden="true"></i> {{ t('Back to Tripteev') }}
        </router-link>
        <div class="ecosystem-actions">
          <Languages type="right"></Languages>
          <EcosystemUserMenu></EcosystemUserMenu>
        </div>
      </header>

      <main class="ecosystem-main">
        <div v-if="loading" class="text-center py-5">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>
        <div v-else-if="errored" class="text-center py-5">
          <p>{{ t('We apologize, we are unable to retrieve the information at this time.') }}</p>
          <button class="btn btn-default" v-on:click="load()">{{ t('Try again') }}</button>
        </div>
        <div v-else-if="pending" class="tripteev">
          <div class="tripteev-intro">
            <img :src="logo" alt="Tripteev" class="tripteev-logo" />
            <h1 class="tripteev-title">{{ t('Cancel invoice') }}</h1>
            <p class="tripteev-subtitle">{{ t('Check the invoice that will be canceled.') }}</p>
          </div>

          <div class="tripteev-box tripteev-summary">
            <div class="d-flex justify-content-between align-items-start mb-3">
              <h5 class="mb-0">{{ t('Invoice') }} #{{ pending.order.id }}</h5>
              <span class="badge badge-soft-danger font-size-12 text-uppercase">{{ t('Awaiting payment') }}</span>
            </div>

            <dl>
              <div>
                <dt>{{ t('Charge') }}</dt>
                <dd>{{ pending.type == 'adhesion' ? t('Membership') : t('Monthly fee') }}</dd>
              </div>
              <div>
                <dt>{{ t('Expires on') }}</dt>
                <dd>{{ pending.expires }}</dd>
              </div>
              <div class="is-total">
                <dt>{{ t('Total') }}</dt>
                <dd>{{ pending.total | currency }}</dd>
              </div>
            </dl>

            <div class="tripteev-note">
              <i class="bx bx-info-circle" aria-hidden="true"></i>
              <span>{{ t('The PIX generated for this invoice will no longer be valid. You can generate a new invoice whenever you want.') }}</span>
            </div>

            <button class="btn btn-danger btn-lg btn-block text-uppercase" :disabled="submitting" v-on:click="cancel()">
              {{ t('Cancel invoice') }}
              <b-spinner v-if="submitting" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
            </button>
            <router-link to="/tripteev" class="btn btn-outline-default btn-lg btn-block text-uppercase mt-2">
              {{ t('Keep invoice') }}
            </router-link>
          </div>
        </div>
      </main>
    </div>
  </Layout>
</template>
